import {RouteProps} from 'config/navigation';

import SubCategories from './sub-categories';
import CreateSubCategory from './create-sub-category';
import EditSubCategory from './edit-sub-category';
import {FaList} from 'react-icons/fa';

const subCategoriesPages: RouteProps = {
  name: 'Sub categorias',
  path: 'sub-categories',
  permission: 'subCategories.findAll',
  icon: <FaList />,
  subRoutes: [
    {
      path: '',
      element: <SubCategories />,
      permissions: ['subCategories.findAll'],
    },
    {
      path: 'create',
      element: <CreateSubCategory />,
      permissions: ['subCategories.findOne'],
    },
    {
      path: ':id',
      element: <EditSubCategory />,
      permissions: ['subCategories.findOne'],
    },
  ],
};

export default subCategoriesPages;
